import { render, staticRenderFns } from "./FileDialog.vue?vue&type=template&id=a3804794&scoped=true&"
import script from "./FileDialog.vue?vue&type=script&lang=js&"
export * from "./FileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3804794",
  null
  
)

export default component.exports